import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo } from 'react';
import { NotificationFeed, NotificationItem } from '@atlassian/notification-common';
import { useGroupedNotifications, useIsMarkAllAsReadVisible, useNotificationReadActions, useNotificationsLoadingState, useNotificationStateFilters } from '@atlassian/notification-store';
function NotificationList(_ref) {
  var updateGroupingHeaders = _ref.updateGroupingHeaders;
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  var _useNotificationsLoad = useNotificationsLoadingState(filters),
    _useNotificationsLoad2 = _slicedToArray(_useNotificationsLoad, 1),
    currentCategoryState = _useNotificationsLoad2[0];
  var _useIsMarkAllAsReadVi = useIsMarkAllAsReadVisible(filters),
    _useIsMarkAllAsReadVi2 = _slicedToArray(_useIsMarkAllAsReadVi, 1),
    isMarkAllAsReadVisible = _useIsMarkAllAsReadVi2[0];
  var notificationReadActions = useNotificationReadActions();
  var notificationSections = useGroupedNotifications(filters);
  var notificationTimeGroups = useMemo(function () {
    return notificationSections.filter(function (notificationTimeGroup) {
      return notificationTimeGroup.data.length > 0;
    });
  }, [notificationSections]);
  return /*#__PURE__*/React.createElement(NotificationFeed, {
    notificationTimeGroups: notificationTimeGroups,
    fetchState: currentCategoryState.fetchState,
    isMarkAllAsReadVisible: isMarkAllAsReadVisible,
    markAllNotificationsRead: notificationReadActions.handleMarkAllNotificationsRead,
    updateGroupingHeaders: updateGroupingHeaders,
    renderDataItem: function renderDataItem(notification, listIndex, forceContentLoading) {
      return /*#__PURE__*/React.createElement(NotificationItem, {
        notification: notification,
        listIndex: listIndex,
        forceContentLoading: forceContentLoading,
        markBulkNotifications: notificationReadActions.handleMarkBulkNotifications
      });
    }
  });
}
export default NotificationList;